import React, { useEffect, useMemo, useState } from "react";
import { API_BASE } from "../api/config";
// WAREHOUSE_REMOVE_FAKE_FRONTEND_LOGIN_V2
// WAREHOUSE_NEW_FLOW_UI_STRUCTURE_V1
// WAREHOUSE_NOTIFICATION_DRAWER_V1
// WAREHOUSE_ROLE_UI_LOGIN_V1
import Layout from "../components/Layout";
import "./WarehouseDashboardPage.css";
import WarehouseInventoryPanel from "./WarehouseInventoryPanel";
import WarehouseLocationInventoryDetailPanel from "./WarehouseLocationInventoryDetailPanel";
// WAREHOUSE_CLEAN_LOCATION_INVENTORY_DETAIL_V1
import WarehouseTransferPanel from "./WarehouseTransferPanel";
import WarehouseAllocationPanel from "./WarehouseAllocationPanel";
import WarehouseReadyPlansPanel from "./WarehouseReadyPlansPanel";
import WarehouseShopAccessPanel from "./WarehouseShopAccessPanel";
import WarehouseDamagePanel from "./WarehouseDamagePanel";
import WarehouseAccessoryPanel from "./WarehouseAccessoryPanel";
import OfficeAssignedTransfersPanel from "./OfficeAssignedTransfersPanel";
import WarehouseTransferIssueNotificationBox from "./WarehouseTransferIssueNotificationBox";
import WarehouseTransferHistoryPanel from "./WarehouseTransferHistoryPanel";
import WarehouseTransferIssueActionBox from "./WarehouseTransferIssueActionBox";

const STORAGE_KEY = "erpWarehouseUser";

function formatDate(value) {
  if (!value) return "-";
  return new Date(value).toLocaleString();
}


function WarehouseSectionIcon({ section }) {
  const paths = {
    DASHBOARD: ["M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z"],
    INVENTORY_OVERVIEW: ["m3 7 9-4 9 4v10l-9 4-9-4V7Z", "m3 7 9 4 9-4M12 11v10M8 5l9 4"],
    TRANSFER: ["M3 7h14l-4-4M21 17H7l4 4M17 7l-4 4M7 17l4-4"],
    TRANSFER_SUMMARY: ["M6 3h12v18H6zM9 7h6M9 11h6M9 15h3"],
    ACCESSORY: ["M5 7h14l2 14H3L5 7ZM8 7V5a4 4 0 0 1 8 0v2"],
    PROMOTION: ["M3 10h18v4H3zM5 14v7h14v-7M12 10v11", "M12 10H8a3 3 0 1 1 3-3l1 3ZM12 10h4a3 3 0 1 0-3-3l-1 3Z"],
    ASSET: ["M4 21V5h10v16M14 10h6v11M2 21h20M7 8h4M7 12h4M7 16h4M17 13h1M17 17h1"],
    DAMAGE: ["m12 3 10 18H2L12 3ZM12 9v5M12 17h.01"],
    OFFICE_TRANSFER: ["M3 5h8l2 3h8v13H3V5ZM7 14h10l-3-3M17 14l-3 3"],
    REPORTS: ["M4 3v18h17M8 16v-4M13 16V8M18 16V5"],
  };
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">{(paths[section] || paths.INVENTORY_OVERVIEW).map((d, index) => <path key={index} d={d} />)}</svg>;
}

export default function WarehouseDashboardPage() {
  const [loginForm, setLoginForm] = useState({
    username: "",
    password: "",
  });

  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch {
      return null;
    }
  });

  const [selectedLocation, setSelectedLocation] = useState("");
  const [inventoryLocation, setInventoryLocation] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingNoti, setLoadingNoti] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [activeSection, setActiveSection] = useState("DASHBOARD");
  const [detailInventoryLocation, setDetailInventoryLocation] = useState("");
  const [requestedTransferId, setRequestedTransferId] = useState('');
  const [savedTransferSelected, setSavedTransferSelected] = useState(false);

  useEffect(() => { setRequestedTransferId(''); setSavedTransferSelected(false); }, [selectedLocation]);

  const allowedLocations = useMemo(() => {
    return Array.isArray(user?.allowedLocations) ? user.allowedLocations : [];
  }, [user]);

  const inventoryLocations = useMemo(() => {
    if (Array.isArray(user?.inventoryLocations) && user.inventoryLocations.length > 0) {
      return user.inventoryLocations;
    }

    return allowedLocations;
  }, [user, allowedLocations]);

  async function login(event) {
    event.preventDefault();

    try {
      setLoadingLogin(true);
      setError("");
      setSuccessMsg("");
const response = await fetch(`${API_BASE}/api/erp/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginForm),
      });

      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.message || "Login failed");
      }

      setUser(data.user);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data.user));
      if (data.transferToken) localStorage.setItem('erpWarehouseTransferToken', data.transferToken);
      setSelectedLocation(data.user?.allowedLocations?.[0] || "");
      setInventoryLocation(
        data.user?.inventoryLocations?.[0] ||
          data.user?.allowedLocations?.[0] ||
          ""
      );
      setActiveSection("DASHBOARD");
      setDetailInventoryLocation("");
      setSuccessMsg("Login success");
    } catch (err) {
      setError(err.message);
      setUser(null);
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem('erpWarehouseTransferToken');
    } finally {
      setLoadingLogin(false);
    }
  }

  function logout() {
    setUser(null);
    setNotifications([]);
    setSelectedLocation("");
    setInventoryLocation("");
    setActiveSection("DASHBOARD");
    setDetailInventoryLocation("");
    setNotificationOpen(false);
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('erpWarehouseTransferToken');
  }

  async function loadNotifications() {
    if (!user?.username) return;

    try {
      setLoadingNoti(true);
      setError("");

      const response = await fetch(
        `${API_BASE}/api/erp/notifications?username=${encodeURIComponent(user.username)}&limit=50`
      );

      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.message || "Failed to load notifications");
      }

      setNotifications(Array.isArray(data.rows) ? data.rows : []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingNoti(false);
    }
  }

  async function markRead(row) {
    try {
      await fetch(`${API_BASE}/api/erp/notifications/${row.id}/read`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: user.username,
        }),
      });

      await loadNotifications();
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => {
    if (allowedLocations.length > 0 && !selectedLocation) {
      setSelectedLocation(allowedLocations[0]);
    }
  }, [allowedLocations, selectedLocation]);

  useEffect(() => {
    if (inventoryLocations.length > 0 && !inventoryLocation) {
      setInventoryLocation(inventoryLocations[0]);
    }
  }, [inventoryLocations, inventoryLocation]);

  useEffect(() => {
    loadNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.username]);

  const unreadNotificationCount = useMemo(() => {
    return notifications.filter((row) => !row.isRead).length;
  }, [notifications]);

  function openInventoryDetail(locationCode) {
    const code = String(locationCode || "").trim().toUpperCase();
    if (!code) return;

    setDetailInventoryLocation(code);
    setInventoryLocation(code);
    setActiveSection("INVENTORY_DETAIL");

    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      window.scrollTo(0, 0);
    }
  }

  const content = (
    <div className={`warehousePage ${user && activeSection === "TRANSFER" ? "warehousePage--transfer" : ""}`}>
      <header className="warehouseHero">
        <div className="warehouseHeroIdentity">
          <div className="warehouseHeroMark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 20V8l9-5 9 5v12H3Z" /><path d="M8 20V10h8v10M8 14h8M8 17h8" />
            </svg>
          </div>
          <div>
          <div className="warehouseHero__tag">WAREHOUSE PORTAL</div>
          <h1>Warehouse Dashboard</h1>
          <p className="warehouseHeroSubtitle">Inventory · Transfers · Operations</p>
          </div>
        </div>

        {user && (
          <div className="warehouseHeroActions">
            <button
              type="button"
              className="warehouseTopNotificationBtn"
              onClick={() => {
                setNotificationOpen(true);
                loadNotifications();
              }}
            >
              <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />
              </svg>
              Notifications
              {unreadNotificationCount > 0 && (
                <span>{unreadNotificationCount}</span>
              )}
            </button>

            <button type="button" onClick={logout} className="warehouseLogoutBtn">
              Logout
            </button>
          </div>
        )}
      </header>

      {error && <div className="warehouseAlert warehouseAlert--error">{error}</div>}
      {successMsg && <div className="warehouseAlert warehouseAlert--success">{successMsg}</div>}

      {user && notificationOpen && (
        <div
          className="warehouseNotificationOverlay"
          onClick={() => setNotificationOpen(false)}
        >
          <aside
            className="warehouseNotificationDrawer"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="warehouseNotificationDrawer__head">
              <div>
                <span>🔔 NOTIFICATIONS</span>
                <h2>Warehouse Notifications</h2>
                <p>Action လိုတဲ့ warehouse notification တွေကို ဒီမှာပဲကြည့်မယ်။</p>
              </div>

              <button
                type="button"
                className="warehouseDrawerCloseBtn"
                onClick={() => setNotificationOpen(false)}
              >
                ×
              </button>
            </div>

            <div className="warehouseNotificationDrawer__actions">
              <button type="button" onClick={loadNotifications} disabled={loadingNoti}>
                {loadingNoti ? "Loading..." : "Refresh"}
              </button>
            </div>

            {notifications.length === 0 ? (
              <div className="warehouseNotificationDrawer__empty">
                {/* WAREHOUSE_NOTIFICATION_SHOW_TRANSFER_ISSUES_V1 */}<WarehouseTransferIssueNotificationBox selectedLocation={selectedLocation} />
              </div>
            ) : (
              <div className="warehouseNotificationDrawer__list">
                {notifications.map((row) => (
                  <div
                    key={row.id}
                    className={`warehouseDrawerNotiItem ${row.isRead ? "isRead" : ""}`}
                  >
                    <div className="warehouseDrawerNotiItem__icon">
                      {row.emoji || "🔔"}
                    </div>

                    <div className="warehouseDrawerNotiItem__body">
                      <h4>{row.title}</h4>
                      <p>{row.message}</p>

                      <div className="warehouseDrawerNotiItem__meta">
                        <span>{row.targetLocationCode || "ALL"}</span>
                        <span>{row.notificationType || "-"}</span>
                        <span>{formatDate(row.createdAt)}</span>
                      </div>

                      <button
                        type="button"
                        onClick={() => markRead(row)}
                        disabled={row.isRead}
                      >
                        {row.isRead ? "Read" : "Mark Read"}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </aside>
        </div>
      )}

      {!user ? (
        <form className="warehouseLoginCard" onSubmit={login}>
          <h2>Warehouse Staff Login</h2>

          <label>
            <span>Username</span>
            <input
              value={loginForm.username}
              onChange={(e) =>
                setLoginForm((prev) => ({
                  ...prev,
                  username: e.target.value,
                }))
              }
              placeholder="Enter warehouse username"
            />
          </label>

          <label>
            <span>Password</span>
            <input
              type="password"
              value={loginForm.password}
              onChange={(e) =>
                setLoginForm((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
              placeholder="Enter password"
            />
          </label>

          <button type="submit" disabled={loadingLogin}>
            {loadingLogin ? "Checking..." : "Login"}
          </button>

        </form>
      ) : (
        <>
          <div className="warehouseContextBar">
            <div className="warehouseContextFields">
              <label className="warehouseContextField">
                <span>Working warehouse</span>
                <select value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)}>
                  {allowedLocations.map((loc) => <option key={loc} value={loc}>{loc}</option>)}
                </select>
              </label>
              {(activeSection === "INVENTORY_OVERVIEW" || activeSection === "INVENTORY_DETAIL") && (
                <label className="warehouseContextField">
                  <span>Inventory location</span>
                  <select value={inventoryLocation} onChange={(e) => openInventoryDetail(e.target.value)}>
                    {inventoryLocations.map((loc) => <option key={loc} value={loc}>{loc}</option>)}
                  </select>
                </label>
              )}
            </div>
            <details className="warehouseAccountDetails">
              <summary>
                <span className="warehouseAccountAvatar" aria-hidden="true">{String(user.displayName || user.username || "W").charAt(0).toUpperCase()}</span>
                <span>{user.displayName || user.username}</span>
                <span className="warehouseAccountChevron" aria-hidden="true">⌄</span>
              </summary>
              <dl>
                <div><dt>Role</dt><dd>{String(user.role || "-").replace(/_/g, " ")}</dd></div>
                <div><dt>Warehouses</dt><dd>{allowedLocations.join(", ") || "-"}</dd></div>
                <div><dt>Brands</dt><dd>{Array.isArray(user.brands) ? user.brands.join(", ") : "-"}</dd></div>
              </dl>
            </details>
          </div>

          <nav className="warehouseSectionTabs" aria-label="Warehouse sections">
            {[
              ["DASHBOARD", "Dashboard"],
              ["INVENTORY_OVERVIEW", "Inventory Overview"],
              ["TRANSFER", "Product Transfer"],
              ["TRANSFER_SUMMARY", "Transfer Summary"],
              ["ACCESSORY", "Carrier Bag / Supplies"],
              ["PROMOTION", "Promotion Items"],
              ["ASSET", "Office / Shop Assets"],
              ["DAMAGE", "Damage Product"],
              ["OFFICE_TRANSFER", "Office Transfer"],
              ["REPORTS", "Reports"],
            ].map(([section, label]) => {
              const isActive = activeSection === section || (section === "INVENTORY_OVERVIEW" && activeSection === "INVENTORY_DETAIL");
              return (
                <button key={section} type="button" data-section={section} className={isActive ? "isActive" : ""}
                  aria-current={isActive ? "page" : undefined} onClick={() => setActiveSection(section)}>
                  <span className="warehouseNavIcon"><WarehouseSectionIcon section={section} /></span>
                  {label}
                </button>
              );
            })}
          </nav>

          {activeSection === "DASHBOARD" && (
            <>
              <div className="warehouseCards">
                <button
                  type="button"
                  className="warehouseCard warehouseCardButton" data-section="INVENTORY_OVERVIEW"
                  onClick={() => setActiveSection("INVENTORY_OVERVIEW")}
                >
                  <div className="warehouseCardIcon"><WarehouseSectionIcon section="INVENTORY_OVERVIEW" /></div>
                  <h3>Inventory Overview</h3>
                  <p>Shop / warehouse inventory ကို location page သီးသန့်ဖွင့်ကြည့်ရန်။</p>
                </button>

                <button
                  type="button"
                  className="warehouseCard warehouseCardButton" data-section="TRANSFER"
                  onClick={() => setActiveSection("TRANSFER")}
                >
                  <div className="warehouseCardIcon"><WarehouseSectionIcon section="TRANSFER" /></div>
                  <h3>Product Transfer</h3>
                  <p>Warehouse → Shop / Warehouse → Warehouse transfer flow။</p>
                </button>

                <button
                  type="button"
                  className="warehouseCard warehouseCardButton" data-section="ACCESSORY"
                  onClick={() => setActiveSection("ACCESSORY")}
                >
                  <div className="warehouseCardIcon"><WarehouseSectionIcon section="ACCESSORY" /></div>
                  <h3>Carrier Bag / Supplies</h3>
                  <p>Hangten / Prettyfit carrier bag နှင့် store supplies ပို့ရန်။</p>
                </button>

                  {/* FORCE_WAREHOUSE_OFFICE_TRANSFER_TAB_CARD_V2 CARD */}
                  <button
                    type="button"
                    className="warehouseCard warehouseCardButton" data-section="OFFICE_TRANSFER"
                    onClick={() => setActiveSection("OFFICE_TRANSFER")}
                  >
                    <div className="warehouseCardIcon"><WarehouseSectionIcon section="OFFICE_TRANSFER" /></div>
                    <h3>Office Transfer</h3>
                    <p>Office က Excel/manual upload ချပေးထားတဲ့ assigned transfer list ကို pick & dispatch လုပ်ရန်။</p>
                  </button>

                <button
                  type="button"
                  className="warehouseCard warehouseCardButton" data-section="DAMAGE"
                  onClick={() => setActiveSection("DAMAGE")}
                >
                  <div className="warehouseCardIcon"><WarehouseSectionIcon section="DAMAGE" /></div>
                  <h3>Damage Product</h3>
                  <p>Office damage list ကို warehouse က receive လုပ်ရန်။</p>
                </button>
              </div>

              <div className="warehouseFlowPanel">
                <div className="warehouseFlowPanel__head">
                  <div>
                    <span>INVENTORY OVERVIEW</span>
                    <h2>View location inventory</h2>
                    <p>Location တစ်ခုနှိပ်ရင် detail page သီးသန့်ဖွင့်မယ်။</p>
                  </div>
                </div>

                <div className="warehouseLocationGrid">
                  {inventoryLocations.map((loc) => (
                    <button
                      key={loc}
                      type="button"
                      className="warehouseLocationCard" data-kind={allowedLocations.includes(loc) ? "warehouse" : loc.endsWith("PF") ? "prettyfit" : "hangten"}
                      onClick={() => openInventoryDetail(loc)}
                    >
                      <div className="warehouseLocationIcon"><WarehouseSectionIcon section="INVENTORY_OVERVIEW" /></div>
                      <b>{loc}</b>
                      <span>Open {loc} inventory</span>
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}

          {activeSection === "INVENTORY_OVERVIEW" && (
            <div className="warehouseFlowPanel">
              <div className="warehouseFlowPanel__head">
                <div>
                  <span>INVENTORY OVERVIEW</span>
                  <h2>Choose location</h2>
                  <p>မင်း view permission ရှိတဲ့ location တွေပဲပေါ်မယ်။</p>
                </div>
              </div>

              <div className="warehouseLocationGrid">
                {inventoryLocations.map((loc) => (
                  <button
                    key={loc}
                    type="button"
                    className="warehouseLocationCard" data-kind={allowedLocations.includes(loc) ? "warehouse" : loc.endsWith("PF") ? "prettyfit" : "hangten"}
                    onClick={() => openInventoryDetail(loc)}
                  >
                    <div className="warehouseLocationIcon"><WarehouseSectionIcon section="INVENTORY_OVERVIEW" /></div>
                    <b>{loc}</b>
                    <span>Open {loc} inventory</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {activeSection === "INVENTORY_DETAIL" && (
            <div className="warehouseDetailPage">
              <button
                type="button"
                className="warehouseBackBtn"
                onClick={() => setActiveSection("INVENTORY_OVERVIEW")}
              >
                ← Back
              </button>

              <div className="warehouseDetailHeader">
                <div>
                  <span>INVENTORY DETAIL</span>
                  <h2>{detailInventoryLocation || inventoryLocation} Inventory Overview</h2>
                  <p>
                    Only {detailInventoryLocation || inventoryLocation} stock is shown here.
                    Working warehouse action permission မပြောင်းပါ။
                  </p>
                </div>
              </div>

              <WarehouseLocationInventoryDetailPanel
                user={user}
                locationCode={detailInventoryLocation || inventoryLocation}
              />
            </div>
          )}

          {activeSection === "TRANSFER" && (
            <>
              <WarehouseReadyPlansPanel user={user} selectedLocation={selectedLocation} initialPlanId={requestedTransferId} onSelectionChange={setSavedTransferSelected} onOpenSummary={() => { setRequestedTransferId(''); setActiveSection("TRANSFER_SUMMARY"); }} />
              <WarehouseShopAccessPanel user={user} selectedLocation={selectedLocation} />
              {!savedTransferSelected && <WarehouseTransferPanel user={user} selectedLocation={selectedLocation} />}
            </>
          )}

          {activeSection === "TRANSFER_SUMMARY" && (
            <WarehouseAllocationPanel user={user} selectedLocation={selectedLocation} onOpenTransfer={id => { setRequestedTransferId(id || ''); setActiveSection("TRANSFER"); }} />
          )}

                          {/* FIX_OFFICE_TRANSFER_RENDER_JSX_POSITION_V1 */}
              {activeSection === "OFFICE_TRANSFER" && (
                <>
                  {/* WAREHOUSE_OFFICE_TRANSFER_ISSUE_BOX_FORCE_RENDER_REAL_V4 */}
                  <WarehouseTransferIssueActionBox
                    user={user}
                    selectedLocation={selectedLocation}
                  />

                  <OfficeAssignedTransfersPanel
                    user={user}
                    selectedLocation={selectedLocation}
                  />
                </>
              )}


            {activeSection === "ACCESSORY" && (
            <WarehouseAccessoryPanel user={user} selectedLocation={selectedLocation} />
          )}

          {activeSection === "DAMAGE" && (
            <WarehouseDamagePanel user={user} selectedLocation={selectedLocation} />
          )}

          {activeSection === "PROMOTION" && (
            <div className="warehousePlaceholderPanel">
              <span>PROMOTION ITEMS</span>
              <h2>Promotion Items</h2>
              <p>
                Office purchase → Warehouse stock in → Issue to shop → Promotion end
                → Return remaining items flow ကို ဒီ section မှာ ဆက်ချိတ်မယ်။
              </p>
            </div>
          )}

          {activeSection === "ASSET" && (
            <div className="warehousePlaceholderPanel">
              <span>OFFICE / SHOP ASSETS</span>
              <h2>Office / Shop Assets</h2>
              <p>
                Asset stock in → Assign to shop → Shop receive → Return / damaged / lost flow
                ကို ဒီ section မှာ ဆက်ချိတ်မယ်။
              </p>
            </div>
          )}

                      {activeSection === "REPORTS" && (
              <>
                {/* WAREHOUSE_REPORTS_TRANSFER_HISTORY_REAL_V1 */}
                <WarehouseTransferHistoryPanel selectedLocation={selectedLocation} />
              </>
            )}

            <div className="warehouseNotificationPanel">
            <div className="warehouseNotificationPanel__head">
              <div>
                <div className="warehouseNotificationPanel__tag">🔔 NOTIFICATIONS</div>
                <h2>Warehouse Notifications</h2>
              </div>

              <button type="button" onClick={loadNotifications} disabled={loadingNoti}>
                {loadingNoti ? "Loading..." : "Refresh"}
              </button>
            </div>

            {notifications.length === 0 ? (
              <div className="warehouseNotificationEmpty">
                No notifications yet.
              </div>
            ) : (
              <div className="warehouseNotificationList">
                {notifications.map((row) => (
                  <div
                    key={row.id}
                    className={`warehouseNotificationItem ${row.isRead ? "isRead" : ""}`}
                  >
                    <div className="warehouseNotificationItem__emoji">
                      {row.emoji || "🔔"}
                    </div>

                    <div className="warehouseNotificationItem__body">
                      <h4>{row.title}</h4>
                      <p>{row.message}</p>

                      <div className="warehouseNotificationItem__meta">
                        <span>{row.targetLocationCode || "ALL"}</span>
                        <span>{row.notificationType || "-"}</span>
                        <span>{formatDate(row.createdAt)}</span>
                      </div>
                    </div>

                    <button type="button" onClick={() => markRead(row)} disabled={row.isRead}>
                      {row.isRead ? "Read" : "Mark Read"}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );

  // Signed-in warehouse staff work inside the warehouse portal. The shared ERP
  // navigation belongs to the signed-out entry page, not this workspace.
  return user
    ? <main className="warehouseWorkspace" aria-label="Warehouse workspace">{content}</main>
    : <Layout title="Warehouse">{content}</Layout>;
}
